import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetCreditBalancesQuery } from '@/services/endpoints/credits';
import { formatCredits } from '@/features/campaigns/v2/credits/utils/formatCredits';
import { isCreditsFeatureUnavailable } from '@/features/campaigns/v2/credits/utils/isCreditsFeatureUnavailable';

export const CreditsBadge: FC = () => {
  const { t, i18n } = useTranslation('comuni');
  const workspace = useWorkspace();

  const { data, isLoading, isFetching, isError, error, isUninitialized } = useGetCreditBalancesQuery({ workspaceId: workspace.id }, { skip: !workspace.id });

  const total = Array.isArray(data) && !isLoading && !isFetching && !isUninitialized ? data.reduce((acc, item) => acc + (item.available ?? 0), 0) : null;

  if (isCreditsFeatureUnavailable(error)) {
    return null;
  }

  if (isError) {
    return null;
  }

  if (total === null) {
    return null;
  }

  return (
    <div className='rounded-xl border border-gray-200 px-4 py-2 text-right'>
      <div className='text-xs font-medium text-tertiary-600'>{t('credits.available')}</div>
      <div className='text-xl font-extrabold text-brand-600'>{formatCredits(total, i18n.language)}</div>
    </div>
  );
};
